import "./EmployeeRecordAddress.css";
import { ESSENTIAL_DESCRIPTIONS } from "./employeeRecordConfig";

type EmployeeRecordAddressProps = {
    address: string;
    onChange: (label: string, data: string) => void;
};

export const EmployeeRecordAddress = ({ address, onChange }: EmployeeRecordAddressProps) => {
    return (
        <div className="app-employee-record-property">
            <div className="app-employee-record-left">
                <div className="app-employee-record-label">
                    Address
                </div>
            </div>
            <div className="app-employee-record-middle">   
                <div className="app-employee-record-value">
                    <textarea
                        value={address}
                        name="system-address"
                        onChange={(e: any)=>onChange(e.target.name, e.target.value)}
                    />
                </div>
            </div>
            <div className="app-employee-record-right">
                {ESSENTIAL_DESCRIPTIONS.address}
            </div>
        </div>
    );
};